import React, { useState } from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const DreamWeaveTutorial = ({ onFinish }) => {
    const { t } = useTranslation();
    const [step, setStep] = useState(0);

    const tutorialSteps = [
        {
            icon: 'Sparkles',
            title: t('dreamWeaveTutorial.steps.welcome.title'),
            text: t('dreamWeaveTutorial.steps.welcome.text')
        },
        {
            icon: 'Gamepad2',
            title: t('dreamWeaveTutorial.steps.contribute.title'),
            text: t('dreamWeaveTutorial.steps.contribute.text')
        },
        {
            icon: 'LayoutGrid',
            title: t('dreamWeaveTutorial.steps.visualize.title'),
            text: t('dreamWeaveTutorial.steps.visualize.text')
        },
        {
            icon: 'Bot',
            title: t('dreamWeaveTutorial.steps.chat.title'),
            text: t('dreamWeaveTutorial.steps.chat.text')
        },
        {
            icon: 'Trophy',
            title: t('dreamWeaveTutorial.steps.reward.title'),
            text: t('dreamWeaveTutorial.steps.reward.text')
        }
    ];

    const handleNext = () => {
        if (step < tutorialSteps.length - 1) {
            setStep(step + 1);
        } else {
            onFinish();
        }
    };

    const currentStep = tutorialSteps[step];
    const Icon = LucideIcons[currentStep.icon];

    return (
        <div className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center animate-fadeIn p-4">
            <div className="bg-gray-800 border border-indigo-500/50 rounded-2xl shadow-2xl max-w-sm w-full text-white text-center p-8 flex flex-col items-center">
                <div className="p-4 bg-indigo-500/20 rounded-full mb-6">
                    <Icon size={48} className="text-indigo-400" />
                </div>
                <h2 className="text-2xl font-bold mb-4">{currentStep.title}</h2>
                <p className="text-gray-300 mb-8 flex-grow">{currentStep.text}</p>
                
                <div className="flex items-center justify-center space-x-2 mb-8">
                    {tutorialSteps.map((_, index) => (
                        <div
                            key={index}
                            className={`w-2 h-2 rounded-full transition-colors ${index === step ? 'bg-indigo-500' : 'bg-gray-600'}`}
                        />
                    ))}
                </div>

                <button
                    onClick={handleNext}
                    className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-3 px-6 rounded-lg transition-transform transform hover:scale-105"
                >
                    {step === tutorialSteps.length - 1 ? t('dreamWeaveTutorial.finish') : t('dreamWeaveTutorial.next')}
                </button>
            </div>
        </div>
    );
};

export default DreamWeaveTutorial;
